export default "__VITE_ASSET__LSSDnM4E__"